import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const InnerHead = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data);
    };
    fetchData();
  }, []);
  return (
    <section
      className="hero banner d-flex align-items-center justify-content-center text-white text-center position-relative"
      style={{
        height: "70vh",
        overflow: "hidden",
      }}
    >
      <div
        className="background-image"
        style={{
          backgroundImage: `url(${home?.slider1?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          filter: "blur(2px)",
          zIndex: -1,
        }}
      ></div>

      <div className="container mt-4 pt-4">
        <h1 className="">{home?.title[0]?.text}</h1>
        <p className="lead">(Hybrid Mode)</p>
        <div className="conference-date text-white py-2 px-4 mt-4 rounded">
          <h4>{home?.conference_date[0]?.text}</h4>
        </div>
        <div className="conference-organised mt-3 h5 font-weight-medium">
          <h3>{home?.location[0]?.text}</h3>
        </div>
      </div>
    </section>
  );
};

export default InnerHead;
